import { render, staticRenderFns } from "./TripsPage.vue?vue&type=template&id=edf01cd8&scoped=true&"
import script from "./TripsPage.vue?vue&type=script&lang=js&"
export * from "./TripsPage.vue?vue&type=script&lang=js&"
import style0 from "./TripsPage.vue?vue&type=style&index=0&id=edf01cd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf01cd8",
  null
  
)

export default component.exports